export default __webpack_public_path__ + "static/media/90t.38f07c81.jpg";